/**
 * SitemapHandler — hide sample placeholder items from sitemap.
 * Migrated from PRODUCTION dpss-theme.js SitemapHandler class.
 */

import { qsa } from "./utils";

export class SitemapHandler {
  private sampleTexts: string[];

  constructor() {
    this.sampleTexts = [
      "Зразок пункту 3.1",
      "Зразок пункту 3.2",
      "Зразок пункту 3.3",
      "зразок пункту",
      "Зразок",
      "зразок",
    ];
    this.init();
  }

  private init(): void {
    this.hideSampleItems();
    const collapse = document.getElementById("collapseSitemap");
    if (collapse) {
      collapse.addEventListener("shown.bs.collapse", () =>
        this.hideSampleItems(),
      );
    }
  }

  private hideSampleItems(): void {
    qsa(".site-map_list a, .site-map_list span").forEach((element) => {
      const text = element.textContent?.trim() ?? "";
      const href = element.getAttribute("href") ?? "";

      const shouldHide = this.sampleTexts.some(
        (sampleText) =>
          text.includes(sampleText) || href.includes("зразок"),
      );

      if (shouldHide) {
        const li = element.closest("li") as HTMLElement | null;
        if (li) li.style.display = "none";
      }
    });

    qsa(".site-map_list li").forEach((li) => {
      if (li.textContent?.includes("Зразок пункту")) {
        li.remove();
      }
    });
  }
}
